import { NavState } from "@constants/ui";

export const DEFAULT_PAGE_TITLE = "Seedkit";
export const DEFAULT_PAGE_DESCRIPTION = "Seedkit (Social Enterprise Evaluation & Data Platform)";

export const PUBLIC_VERSION = "1.9.1";

export const LOGIN_COOKIE_KEY = "sklogin";
export const LOGIN_COOKIE_DOMAIN = ".seedkit.com.au";

export const CONTEXT_STORAGE_KEY = "skcontext";

export const GLOBAL_CONTEXT_DEFAULTS = {
    signedUp: false,
    authToken: '',
    user: {},
    organisation: {}
};

export const LOGIN_ERROR = "There was an error logging you in. Please try again later.";
export const NOT_ENABLED_ALERT = "This function is not enabled in the current version of Seedkit";

export const ORG_NAME_HELP = "To set, enter a valid number in the ABN field and click the search button.";

export const ContextStatus = {
    OK: "ok",
    LOADING: "loading",
    ERROR: "error"
}

export const CONTEXT_ERROR = "Currently unable to access your organisation's data. Please try again later.";

export const ACCESS_ERROR = "User does not have the required access.";

export const TRIAL_ACCOUNT_TOOLTIP = "If you do not have a valid ABN, you can create a trial account to try out Seedkit's features, but you will be unable to export data or dashboards, or create additional users for your organisation. You can upgrade to a full account at a later time by entering an ABN.";

export const ABN_ERROR = 'Enter a valid ABN. ABN\'s have 11 digits. You can find your ABN by using the <a href="https://abr.business.gov.au/" className="underline" target="_blank" rel="noopener noreferrer">ABN Lookup Service</a>';

export const DEBUGGING_BANNER = { 
    text: "1 March 2024: Our team is currently working hard to improve the site and remove bugs. We appreciate your patience and support of Seedkit.", 
    icon: "bug-slash", 
    fill: "#92400E", 
    foreColor: "text-dark-yellow02",
    bgColor: "#FFF6D4"
};

export const GOT_BETTER_BANNER = { 
    text: "8 April 2024: Seedkit just got better. The new updated and improved Dashboard features are live now! While our team continues to work hard to improve the site, we appreciate your patience and support of Seedkit.", 
    icon: "news", 
    fill: "#FFFFFF", 
    foreColor: "text-white",
    bgColor: "#16BA76"
};

export const TRIAL_BANNER = { 
    text: "This is a trial account. To convert to a full account, <br/>click on the button to the right", 
    icon: "half-battery", 
    fill: "#1A53E3", 
    foreColor: "text-black",
    bgColor: "#D8E3FF",
    button: { 
        icon: "full-battery",
        fill: "#1A53E3",
        variant: "outline"
    },
    tooltip: "You can get a feel and look at most features and functionality Seedkit has to offer, but you won't be able to import and export data or dashboards from Seedkit, or create members for your organisation while in a trial account."
};

export const LOGIN_EXPIRY_CHECK_TIME = 10 * 1000; // 10 seconds
export const INACTIVE_EXPIRY_TIME = 60 * 60 * 1000; // 1 hour

export const DEFAULT_OPEN_GRAPH_IMAGE = "images/logo_1200x630_2.jpg";
export const DEFAULT_TWITTER_IMAGE = "images/logo_1200x675_2.jpg";

export const LoginStatus = {
    UNKNOWN: "",
    LOGGED_IN: "in",
    LOGGED_OUT: "out"
};

export const DOMAIN_EXISTS_ERROR = "This domain already exists. Please enter another.";
export const NO_DOMAIN_ERROR = "You need to enter a domain name.";

export const NO_NEED_ERROR = "You need to select a category.";

export const OUTCOME_AREA_EXISTS_ERROR = "This outcome area already exists. Please enter another.";

export const DuplicateMessage = {
    PATHWAY_UNAVAILABLE: "The only available duplication option is copying to another pathway and there are not enough pathways for this.",
    COPY_OPTION_NOT_SELECTED: "Unable to complete this operation as no copy type has been selected.",
    PATHWAY_NOT_SELECTED: "Unable to complete this operation as no destination pathway has been selected.",
    COHORT_NOT_SELECTED: "Unable to complete this operation as no cohort has been selected."
};

export const PasswordIconType = {
    OPEN: "open",
    CLOSED: "closed"
};

export const PasswordStrengthUI = [
    {
        TEXT: "very weak",
        COLOR: "text-red",
        ICON: PasswordIconType.OPEN
    },
    {
        TEXT: "very weak",
        COLOR: "text-red",
        ICON: PasswordIconType.OPEN
    },
    {
        TEXT: "weak",
        COLOR: "text-red",
        ICON: PasswordIconType.OPEN
    },
    {
        TEXT: "reasonable",
        COLOR: "text-dark-yellow02",
        ICON: PasswordIconType.CLOSED
    },
    {
        TEXT: "strong",
        COLOR: "text-green04",
        ICON: PasswordIconType.CLOSED
    }
];

export const PasswordFail = {
    LENGTH: "min",
    DIGITS: "digits",
    SYMBOLS: "symbols",
    SPACES: "spaces"
};

export const PasswordFailChecks = [
    {
        CHECKS: [
            PasswordFail.LENGTH
        ],
        TEXT: "Must be at least 8 characters"
    },
    {
        CHECKS: [
            PasswordFail.DIGITS,
            PasswordFail.SYMBOLS
        ],
        TEXT: "Must contain a number or symbol"
    },
    {
        CHECKS: [
            PasswordFail.SPACES
        ],
        TEXT: "Must not contain any spaces"
    }
];

export const ALL_PASSWORD_FAILS = [
    PasswordFail.LENGTH,
    PasswordFail.DIGITS,
    PasswordFail.SYMBOLS,
    PasswordFail.SPACES
];
